import React from 'react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-beige-dark ml-[0px] mr-[0px]" data-id="element-238">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 h-16 flex pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] gap-[35px] flex-row items-center justify-center" data-id="element-239">
        <div className="flex items-center gap-2" data-id="element-240">
          <img src="https://cdn.magicpatterns.com/uploads/nsstjYDUdvYZEG9tfrBSCC/Zentral_Pro_Png.png" alt="Zentral Pro" className="w-8 h-8 object-contain" data-id="element-241" />
          <span className="font-serif font-bold tracking-wide text-charcoal text-[18px]" data-id="element-242">
            ZENTRAL PRO™
          </span>
        </div>
        <div className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600" data-id="element-243">
          <a href="#sistema" className="hover:text-gold transition-colors" data-id="element-244">
            El Sistema
          </a>
          <a href="#bonos" className="hover:text-gold transition-colors" data-id="element-245">
            Bonos
          </a>
          <a href="#precios" className="hover:text-gold transition-colors" data-id="element-246">
            Precios
          </a>
        </div>
        <a href="#precios" className="bg-gold hover:bg-gold-light text-white px-4 py-2 rounded-sm font-medium text-sm transition-colors pl-[16px] pr-[16px] ml-[5px] mr-[5px]" data-id="element-247">
          Comprar Ahora
        </a>
      </div>
    </nav>;
}